import appConfig from '~/app.config'

export const isFeatureEnabled = (featureName: string): boolean => {
  return appConfig.activeFeatureToggles.some(
    (toggle) => toggle.trim() === featureName
  )
}
